import { window } from './facade/browser';

export function isBs3(): boolean {
  return window.__theme === 'bs4';
}



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/free/utils/ng2-bootstrap-config.ts